import { Component } from '@angular/core';

@Component({
  selector: 'app-athlete-insights',
  templateUrl: './athlete-insights.component.html',
  styleUrls: ['./athlete-insights.component.scss']
})
export class AthleteInsightsComponent  {

}
